export const selectCurrencies = state => state.multiCurrency.currencies;

export const selectPreferredCurrency = state =>
    state.multiCurrency.preferredCurrency ||
    state.multiCurrency.currencies.find(c => c.code === 'SEK');

export const selectIsPreferredCurrencySEK = state =>
    selectPreferredCurrency(state)?.code === 'SEK';

export const selectShowCurrencySelection = state =>
    !!(
        state.multiCurrency.enabled &&
        state.multiCurrency.preferredCurrency &&
        state.multiCurrency.currencies &&
        state.multiCurrency.currencies.length > 0
    );
